import React from 'react';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from './ui/select';
import { CalendarRange } from 'lucide-react';
import { RANGE_OPTIONS, monthOptionsForYear } from '../lib/dateRange';

const YEAR = new Date().getFullYear();
const months = monthOptionsForYear(YEAR);
const monthsPrev = monthOptionsForYear(YEAR - 1);

const DateRangeFilter = ({ value, onChange, className = '' }) => (
  <div className={`inline-flex items-center gap-2 ${className}`}>
    <CalendarRange className="w-4 h-4 text-slate-400" />
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-10 w-44 bg-white text-sm"><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-72">
        {RANGE_OPTIONS.map((r) => (
          <SelectItem key={r.id} value={r.id}>{r.label}</SelectItem>
        ))}
        <div className="border-t border-slate-100 my-1" />
        <div className="px-2 py-1 text-[10px] uppercase tracking-wide text-slate-400">months · {YEAR}</div>
        {months.map((m) => (
          <SelectItem key={m.id} value={m.id}>{m.label}</SelectItem>
        ))}
        <div className="px-2 py-1 text-[10px] uppercase tracking-wide text-slate-400">months · {YEAR - 1}</div>
        {monthsPrev.map((m) => (
          <SelectItem key={m.id} value={m.id}>{m.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export default DateRangeFilter;
